import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/site-data";

export default function WhatsAppButton() {
  const url = `https://wa.me/${COMPANY.phoneRaw}?text=${encodeURIComponent(
    COMPANY.whatsappMessage
  )}`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-green-500 opacity-50 animate-ping" />
      <span className="relative flex items-center justify-center h-14 w-14 rounded-full bg-green-500 text-white shadow-lg shadow-green-500/30 hover:bg-green-600 transition-colors">
        <MessageCircle className="h-7 w-7" />
      </span>
      <span className="absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-slate-900 text-white text-xs font-semibold px-3 py-2 rounded-md opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Chat on WhatsApp
      </span>
    </a>
  );
}
